module.exports = __webpack_public_path__ + "static/media/scissor.1a61f5be.jpg";